import type { ReactNode } from "react";
import styles from "./Notice.module.css";

export function Notice({ tone = "info", title, children }: { tone?: "info" | "ok" | "warn" | "error"; title?: ReactNode; children?: ReactNode }) {
  return (
    <div className={`${styles.notice} ${styles[tone]}`} role={tone === "error" ? "alert" : "status"}>
      {title && <strong className={styles.title}>{title}</strong>}
      {children && <div>{children}</div>}
    </div>
  );
}
